<script lang="ts">import { FeatureSet, ReleaseStage, stateFeatureSet, stateUi, wantAtLeastReleaseStage } from "@infinitro/config";
import { isFullScreenGame, isMobile } from "@infinitro/global";
import HeaderPublic from "./parts/header-public.svelte";
export let onShowPlayerChat;
$: showHeader = !$isFullScreenGame || $isMobile && $isFullScreenGame && $stateUi.games.showNavigationOnMobile;
</script>

{#if showHeader}
	<HeaderPublic {onShowPlayerChat} />
{/if}
